import React from "react";
import SellersTable from "./SellersTable";

const RejectedSellers = () => <SellersTable status="reject" />;

export default RejectedSellers;
